module.exports = __webpack_public_path__ + "static/media/logo_royal.4424e8af.png";